import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'

import { COMPANY_LOGO_PATH } from "../../../constants/Config.js"
import magmaLogo from "../../../assets/images/magma_logo.png"
import Live_Tracking_ham_manu from "../../../assets/images/Live_Tracking_ham_manu.svg"
import At_Work_ham_manu from "../../../assets/images/At_Work_ham_manu.svg"
import Not_Logged_in_ham_manu from "../../../assets/images/Not_Logged_in_ham_manu.svg"
import dashbord_ham_menu from "../../../assets/images/dashbord_ham_menu.svg"
import Activity_ham_manu from "../../../assets/images/Activity_ham_manu.svg"

import Add_Meeting_ham_menu from "../../../assets/images/Add_Meeting_ham_menu.svg"
import Add_RBDM_ham_menu from "../../../assets/images/Add_RBDM_ham_menu.svg"
import Own_Activities_Details_ham_menu from "../../../assets/images/Own_Activities_Details_ham_menu.svg"
import Renewal_Tracking_ham_menu from "../../../assets/images/Renewal_Tracking_ham_menu.svg"
import Attendance_ham_menu from "../../../assets/images/Attendance_ham_menu.svg"
import Grievances_ham_menu from "../../../assets/images/Grievances_ham_menu.svg"
import Activity_Plan_Master_ham_menu from "../../../assets/images/Activity_Plan_Master_ham_menu.svg"
import Reports_ham_menu from "../../../assets/images/Reports_ham_menu.svg"
import Docspedia_ham_menu from "../../../assets/images/Docspedia_ham_menu.svg"
import Logout_ham_menu from "../../../assets/images/Logout_ham_menu.svg"
import { useDispatch, useSelector } from "react-redux";
import { clearLocalStorageAndLogout } from '../../../store/actions/AuthAction'
import BirthdayWorkanniversary_web from "../../../assets/images/BirthdayWorkanniversary_web.svg"
import DensityPenetration_web from "../../../assets/images/DensityPenetration_web.svg"
import eLearning_web from "../../../assets/images/eLearning_web.svg"
import FlashMessage_web from "../../../assets/images/FlashMessage_web.svg"
import TravelLogWeb from "../../../assets/images/TravelLogWeb.svg"



const Offcanvas = (props) => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const { sideBarActive } = props;
    const dispatch = useDispatch();
    const permissions = useSelector(state => state.auth.userPermissions)
    const userDetail = useSelector(state => state.auth.userDetail)

    const handleLogOut = () => {
        dispatch(clearLocalStorageAndLogout({'empCode':userDetail?.employeeCode}))
    }

    

    const checkUserAcessibility = (acess) => {
        let totalPermission = Object.entries(permissions).map(obj => obj[0]);
        if (totalPermission.indexOf(acess) !== -1) {
            return permissions[acess]['view']
        }
        return false
    }


    return (
        <div className="offcanvas offcanvas-start magma_offcanvas" data-bs-scroll="true" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
            {/* <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasExampleLabel">Offcanvas</h5>
            <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div> */}
            <div className="offcanvas-body">
                <div className='offcanvas_logo_container'>
                    {
                        isSafari ? <img src={magmaLogo} className="" loading="lazy" alt="" /> :
                            <img src={COMPANY_LOGO_PATH} className="" loading="lazy" alt="" width={"205px"}/>
                    }

                </div>
                <div className="dropdown mt-3 hambargar_menu_item">
                    <ul>
                        {
                            checkUserAcessibility('DASHBOARD') &&
                            <li>
                                <Link to='/dashboard' className={sideBarActive == 1 ? 'aaaa active' : ''}><img src={dashbord_ham_menu} className="" loading="lazy" alt="" /> Dashboard</Link>
                            </li>
                        }
                        {
                            checkUserAcessibility('LIVETRACKING') &&
                            <li>
                                <Link to='/live-tracking' className={sideBarActive == 2 ? 'aaaa active' : ''}><img src={Live_Tracking_ham_manu} className="" loading="lazy" alt="" /> Live Tracking</Link>
                            </li>
                        }
                        {
                            checkUserAcessibility('LIVETRACKING') &&
                            <li>
                                <Link to='/at-work' className={sideBarActive == 3 ? 'aaaa active' : ''}><img src={At_Work_ham_manu} className="" loading="lazy" alt="" /> At Work</Link>
                            </li>

                        }
                        {
                            checkUserAcessibility('LIVETRACKING') &&
                            <li>
                                <Link to='/not-loggedin' className={sideBarActive == 4 ? 'aaaa active' : ''}><img src={Not_Logged_in_ham_manu} className="" loading="lazy" alt="" />Not Logged in</Link>
                            </li>

                        }
                        {
                            checkUserAcessibility('ACTIVITY') &&
                            <li>
                                <Link to='/activity' className={sideBarActive == 5 ? 'aaaa active' : ''}><img src={Activity_ham_manu} className="" loading="lazy" alt="" /> Activity</Link>
                            </li>

                        }
                        {/* {
                            checkUserAcessibility('ACTIVITY') &&   
                            <li>
                                <Link to='/activity/add-meeting' className={sideBarActive == 6 ? 'aaaa active' : ''}><img src={Add_Meeting_ham_menu} className="" loading="lazy" alt="" /> Add Meeting</Link>
                            </li>

                        } */}
                        {/* checkUserAcessibility('ADMEETING')   */}
                        {
                            checkUserAcessibility('ADDPORTALMEETING')  && 
                            <>
                             <li>
                                <Link to='/activity/view-remaped' className={sideBarActive == 21 ? 'aaaa active' : ''}><img src={Activity_ham_manu} className="" loading="lazy" alt="" /> View Remaped Propspective IMD</Link>
                            </li>


                            <li>
                                <Link to='/activity/add-meeting' className={sideBarActive == 6 ? 'aaaa active' : ''}><img src={Add_Meeting_ham_menu} className="" loading="lazy" alt="" /> Add Meeting</Link>
                            </li>

                            </>
                        }

                        
                        {
                             checkUserAcessibility('RBDMACTIVITY') &&
                            <li>
                                <Link to='/rbdm-th-dashbaord' className={sideBarActive == 17 ? 'aaaa active' : ''}><img src={dashbord_ham_menu} className="" loading="lazy" alt="" /> RBDM/TH DASHBOARD</Link>
                            </li>
                        }

                        {
                            checkUserAcessibility('RBDMACTIVITY') &&
                            <li>
                                <Link to='/rbdm-activity' className={sideBarActive == 7 ? 'aaaa active' : ''}><img src={Add_RBDM_ham_menu} className="" loading="lazy" alt="" /> Add RBDM/TH Activity</Link>
                            </li>
                        }

                        {
                            checkUserAcessibility('ACTIVITY') &&
                            <li>
                                <Link to='/own-activity-detail' className={sideBarActive == 8 ? 'aaaa active' : ''}><img src={Own_Activities_Details_ham_menu} className="" loading="lazy" alt="" /> Own Activities Details</Link>
                            </li>
                        }


                        {
                            checkUserAcessibility('RTM') &&
                            <li>
                                <Link to='/renewal-tracking' className={sideBarActive == 9 ? 'aaaa active' : ''}><img src={Renewal_Tracking_ham_menu} className="" loading="lazy" alt="" /> Renewal Tracking Management</Link>
                            </li>
                        }

                        <li>
                            <a href="https://portal.zinghr.com/2015/pages/authentication/login.aspx" target="_blank" className={sideBarActive == 10 ? 'aaaa active' : ''}><img src={Attendance_ham_menu} className="" loading="lazy" alt="" /> Attendance</a>
                        </li>
                        {/* <li>
                            <a href="https://www.magmainsurance.com/grievance-redressal" target="_blank" className={sideBarActive == 11 ? 'aaaa active' : ''}><img src={Grievances_ham_menu} className="" loading="lazy" alt="" /> Grievances</a>
                        </li> */}
                        {
                            checkUserAcessibility('ACTIONPLANMASTER') &&
                            <li>
                                <Link to='/activity-planmaster' className={sideBarActive == 12 ? 'aaaa active' : ''}><img src={Activity_Plan_Master_ham_menu} className="" loading="lazy" alt="" /> Activity Plan Master</Link>
                            </li>
                        }
                        {/* {
                           checkUserAcessibility('REPORTS') &&     */}
                        <li>
                            <Link to='/reports' className={sideBarActive == 13 ? 'aaaa active' : ''}><img src={Reports_ham_menu} className="" loading="lazy" alt="" /> Reports</Link>
                        </li>
                        {/* } */}

                        {
                            checkUserAcessibility('DOCSPEDIA') &&
                            <li>
                                <Link to='/docs-pedia' className={sideBarActive == 14 ? 'aaaa active' : ''}><img src={Docspedia_ham_menu} className="" loading="lazy" alt="" /> Docspedia</Link>
                            </li>
                        }

                        <li>
                             <a href='https://portal.zinghr.com/2015/pages/authentication/login.aspx' target="_blank" ><img src={eLearning_web} className="" loading="lazy" alt="" style={{height:27}}/> E-Learning</a>
                         </li>

                        {
                             checkUserAcessibility('DASHBOARD') &&
                        <li>
                             <Link to="/birthday-work-aniversary" className={sideBarActive == 16 ? 'aaaa active' : ''}><img src={BirthdayWorkanniversary_web} className="" loading="lazy" alt="" style={{height:27}}/> Birthdays and Work Anniversaries</Link>
                         </li>
                        }
                       
                       {
                        userDetail.djpRole ==="Admin" && 
                        <>
                        <li>
                             <Link to="/add-employee-msg" className={sideBarActive == 17 ? 'aaaa active' : ''}><img src={FlashMessage_web} className="" loading="lazy" alt="" style={{height:27}}/> Add Employee Message</Link>
                         </li>

                         <li>
                             <Link to="/employee-msg-list" className={sideBarActive == 20 ? 'aaaa active' : ''}><img src={FlashMessage_web} className="" loading="lazy" alt="" style={{height:27}}/> Flash Message Files</Link>
                         </li>
                         </>
                       }


                        <li>
                            <Link to='/travel-log' className={sideBarActive == 18 ? 'aaaa active' : ''}><img src={TravelLogWeb} className="" loading="lazy" alt="" style={{height:27}}/> Travel Log</Link>
                        </li>

                        <li>
                            <Link to='/density-penetration' className={sideBarActive == 19 ? 'aaaa active' : ''}><img src={DensityPenetration_web} className="" loading="lazy" alt="" style={{height:27}}/> Density Penetration</Link>
                        </li> 



                        <li>
                            <Link to='#' onClick={() => handleLogOut()} className={sideBarActive == 15 ? 'aaaa active' : ''}><img src={Logout_ham_menu} className="" loading="lazy" alt="" /> Logout</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Offcanvas